'use client'

import { type CSSProperties } from 'react'

import { useSafeBack } from '@/shared/lib/navigation/safe-back'
import { Icon } from '@/shared/ui'

type Props = {
  label?: string
  fallback?: string
  className?: string
  style?: CSSProperties
  onClick?: () => void
}

export const BackButton = ({
  label = '이전으로 돌아가기',
  fallback = '/',
  className,
  style,
  onClick,
}: Props) => {
  const { goBack } = useSafeBack()

  const handleClick = () => {
    if (onClick) {
      onClick()

      return
    }

    goBack(fallback)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      className={className}
      style={style}
    >
      <Icon name="arrow-left" size={24} strokeWidth={1.5} />
      <span className="sr-only">{label}</span>
    </button>
  )
}
